export const InactiveRed = () => {
    return (
        <svg aria-hidden width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0117 0C5.38359 0 0.0117188 5.37188 0.0117188 12C0.0117188 18.6281 5.38359 24 12.0117 24C18.6398 24 24.0117 18.6281 24.0117 12C24.0117 5.37188 18.6398 0 12.0117 0ZM8.21953 8.25C9.04875 8.25 9.72047 8.92031 9.72047 9.75C9.72047 10.5797 9.04875 11.25 8.21953 11.25C7.39031 11.25 6.72 10.5797 6.72 9.75C6.72 8.92031 7.43203 8.25 8.21953 8.25ZM16.5117 17.25H7.46953C6.47625 17.25 6.47625 15.75 7.46953 15.75H16.4695C17.5055 15.75 17.5055 17.25 16.5117 17.25ZM15.7617 11.25C14.9325 11.25 14.2608 10.5797 14.2608 9.75C14.2608 8.92031 14.9325 8.25 15.7617 8.25C16.5909 8.25 17.2612 8.92031 17.2612 9.75C17.2612 10.5797 16.5914 11.25 15.7617 11.25Z"
                fill="#1A1E21"
                fillOpacity="0.26"
            />
        </svg>
    );
};
